/**
 * Main component for About Page
 *
 * @author Creator-Solutions -> Owen Burns
 */

import {
  AboutCaption,
  AboutContentContainer,
  AboutInnerContainer,
  AboutItem,
  AboutGridContainer,
  AboutMe,
} from "./styling/aboutPage.styling";
import { WorkIcon, Birthday, Joined, Role } from "@/assets";

const AboutPage = () => {
  return (
    <AboutContentContainer>
      <AboutInnerContainer>
        <AboutGridContainer>
          <AboutItem>
            <img src={WorkIcon} />
            <AboutCaption>Open to Opportunities</AboutCaption>
          </AboutItem>
          <AboutItem>
            <img src={Birthday} />
            <AboutCaption>September 19th</AboutCaption>
          </AboutItem>
          <AboutItem>
            <img src={Birthday} />
            <AboutCaption>21 January 2024</AboutCaption>
          </AboutItem>
          <AboutItem>
            <img src={Role} />
            <AboutCaption>QA Engineer</AboutCaption>
          </AboutItem>
        </AboutGridContainer>

        <AboutMe
          style={{
            margin: 'auto',
            marginTop: "25px",
            marginBottom: "25px",
          }}
        >
          I consider myself a coding maestro, crafting digital masterpieces with
          the precision of a neurosurgeon and the wit of a stand-up comedian. My
          code is so pristine that even Marie Kondo would give it a thumbs up!
          <br /> <br /> I am fluent in the language of SQL; my queries flow
          smoothly, making databases blush. I've mastered the intricacies of
          data like a linguistic ninja, effortlessly slicing through tables with
          the precision of a code samurai.
          <br />
          <br /> As a QA virtuoso, I effortlessly juggle manual testing like a
          circus performer. I orchestrate API tests with the finesse of a
          maestro and navigate the realm of automation with the precision of a
          code-wielding wizard. Bugs cower in my presence; I am the vigilant
          gatekeeper of quality in the digital realm!
        </AboutMe>
      </AboutInnerContainer>
    </AboutContentContainer>
  );
};

export default AboutPage;
